import classNames from 'classnames';
import { useState } from 'react';
import * as styles from '../Navbar.css';
import type {
  NavbarMenuItemV2ButtonElementProps,
  NavbarMenuItemV2ElementProps,
  NavbarMenuItemV2LinkElementProps,
} from './NavbarMenuItem.type';
import { NavbarMenuItemLinkV2, NavbarMenuItemLogoV2, NavbarMenuItemUserButtonV2 } from './components';
import { NavbarMenuItemDropdownV2 } from './components/NavbarMenuItemDropdown';
import { NavbarMenuItemSearchV2 } from './components/NavbarMenuItemSearch';

export function NavbarMenuItemV2(
  props: NavbarMenuItemV2ElementProps & {
    controlbyselected: boolean | string;
    selected: boolean;
    excludeSeparator?: boolean;
  },
) {
  const { element, children, attributes, excludeSeparator } = props;
  const { type, showOnMobile } = element.attrs || {};
  const [isInsideBurgerContent, setIsInsideBurgerContent] = useState(false);

  const shouldRenderDropdownSeparatelyForEditor =
    attributes?.['data-should-render-dropdown-separately-for-editor'] !== undefined;

  const isEditorViewportDesktop = attributes?.['data-viewport'] === 'desktop';

  const wrapperClassName = classNames({
    'hidden md:flex': showOnMobile === false && type !== 'user_button',
    'flex items-center': shouldRenderDropdownSeparatelyForEditor && isEditorViewportDesktop,
  });

  if (type === 'link' || type === 'button') {
    return (
      <NavbarMenuItemLinkV2
        {...(props as NavbarMenuItemV2LinkElementProps | NavbarMenuItemV2ButtonElementProps)}
        excludeSeparator={excludeSeparator}
        className={classNames(wrapperClassName, props.className)}
      >
        {children}
        {/* Separator is inside the NavbarMenuItemLinkV2 component */}
      </NavbarMenuItemLinkV2>
    );
  }
  if (type === 'user_button') {
    return (
      <NavbarMenuItemUserButtonV2 {...props} className={classNames(wrapperClassName, props.className)}>
        {children}
        {element?.attrs?.type === 'user_button' && element?.attrs?.style === 'button' && (
          <div className={styles.navbarItemSeparatorV2} />
        )}
      </NavbarMenuItemUserButtonV2>
    );
  }
  if (type === 'search') {
    return (
      <NavbarMenuItemSearchV2 {...props} className={classNames(wrapperClassName, props.className)}>
        <div className={styles.navbarItemSeparatorV2} />
      </NavbarMenuItemSearchV2>
    );
  }
  if (type === 'logo') {
    return (
      <NavbarMenuItemLogoV2 {...props} className={classNames(wrapperClassName, props.className)}>
        {children}
        <div className={styles.navbarItemSeparatorV2} />
      </NavbarMenuItemLogoV2>
    );
  }

  return (
    <>
      {shouldRenderDropdownSeparatelyForEditor ? (
        <div className={wrapperClassName || 'contents'}>{children}</div>
      ) : (
        <NavbarMenuItemDropdownV2
          ref={(ref) => setIsInsideBurgerContent(!!ref?.closest('.navbar-menu-burger-content')?.contains(ref))}
          forceShowAccordion={isInsideBurgerContent}
          {...props}
          className={classNames(wrapperClassName, props.className)}
        >
          {children}
          {/* Separator is inside the NavbarMenuItemDropdown component */}
        </NavbarMenuItemDropdownV2>
      )}
    </>
  );
}
